import './App.css';
import Landing from './sections/Landing.js'

function App() {
  return (
    <>
    <Landing />
    </>
  );
}

export default App;
